import {
  SupplierRequestCancellationReason,
  SupplierVettingStatus,
} from './enums/';
import { EntityTypes } from './enums/entityTypes';
import { SupplierRequestDoc } from './supplierRequest';

export interface SupplierVettingRequest {
  vettingId: string;
  requestId: string;
  orgId: string;
  customerOrgId: string;
  entityType: EntityTypes.supplierVettingRequest;
  orgName: string;
  customerOrgName: string;
  status: SupplierVettingStatus;
  locations?: string[];
  timeframe?: string;
  budget?: string;
  unitVolume?: string;
  supportingDocuments?: SupplierRequestDoc[];
  additionalResources?: AdditionalResource[];
  shareSupplierRequestDetails?: boolean;
  assessments: {
    [key: string]: SupplierVettingAssessmentRecord;
  };
  vettingCategories?: string[];
  created: number;
  lastUpdated: number;
  completedDate?: number;
  cancellationReason?: SupplierRequestCancellationReason;
}

export interface SupplierVettingAssessmentRecord {
  assessmentId: string;
  assessmentName: string;
  recordId: string;
  status: SupplierVettingStatus;
}

export interface CreateSupplierVettingRequestAPI {
  orgId: string;
  orgName: string;
  companyName?: string;
  title?: string;
  locations?: string[];
  timeframe?: string;
  budget?: string;
  unitVolume?: string;
  shareSupplierRequestDetails?: boolean;
  questions: SRAssessmentQuestion[];
  supportingDocuments?: SupplierRequestDoc[];
  additionalResources?: AdditionalResource[];
  saveAsTemplate?: boolean;
  templateName?: string;
}

export interface CreateSupplierVettingRequestInput {
  vettingRequestId?: string;
  requestId: string;
  orgId: string;
  customerOrgId: string;
  customerOrgName: string;
  orgName: string;
  status: SupplierVettingStatus;
  locations?: string[];
  timeframe?: string;
  budget?: string;
  unitVolume?: string;
  shareSupplierRequestDetails?: boolean;
  supportingDocuments?: SupplierRequestDoc[];
  additionalResources?: AdditionalResource[];
  assessments?: {
    [key: string]: SupplierVettingAssessmentRecord;
  };
  vettingCategories?: string[];
}

export interface SupplierVettingPreparationMessage {
  vettingId: string;
  requestId: string;
  orgId: string;
  customerOrgId: string;
  orgName: string;
  customerOrgName: string;
}

export interface SRAssessmentQuestion {
  section?: string;
  question: string;
  type: string;
  choices?: string[];
  documentation?: string;
}

export interface AdditionalResource {
  url: string;
  description: string;
}

export interface SupplierVettingRequestTemplate {
  templateId: string;
  templateName: string;
  entityType: EntityTypes.supplierVettingRequestTemplate;
  requestId: string;
  questions: SRAssessmentQuestion[];
  supportingDocuments?: SupplierRequestDoc[];
  additionalResources?: AdditionalResource[];
  locations?: string[];
  timeframe?: string;
  budget?: string;
  unitVolume?: string;
  shareSupplierRequestDetails?: boolean;
  created: number;
  lastUpdated: number;
}

export interface CreateSupplierVettingRequestTemplateInput {
  templateName: string;
  requestId: string;
  questions: SRAssessmentQuestion[];
  locations?: string[];
  timeframe?: string;
  budget?: string;
  unitVolume?: string;
  shareSupplierRequestDetails?: boolean;
  supportingDocuments?: SupplierRequestDoc[];
  additionalResources?: AdditionalResource[];
}
